import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from './layouts/Layout';
import App from './App';
import './index.css';
import { env } from './utils/env';
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import TokenRefresher from './components/TokenRefresher';

import useStore from './store';               
import { initAuthInterceptor } from './api/apiService';

const queryClient = new QueryClient();
// Initialise the interceptor **after** the store exists
initAuthInterceptor(useStore);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* <GoogleOAuthProvider clientId={env.GOOGLE_CLIENT_ID}> */}
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider>
            <TokenRefresher />
            <App/>
            <ReactQueryDevtools initialIsOpen={false} />
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    {/* </GoogleOAuthProvider> */}
  </React.StrictMode>
);
